module.exports = __webpack_public_path__ + "static/media/icon3.2182b303.svg";